import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { OpenPOResponseDto } from "../../../../core/models/vendor/summary/openPOResponseDto";
import { VendorService } from "../../../../core/services/vendor.service";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-vendor-open-po",
  templateUrl: "./vendor-open-po.component.html",
  styleUrls: ["./vendor-open-po.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    SpinnerComponent,
  ],
})
export class VendorOpenPoComponent implements OnInit, OnDestroy, OnChanges {
  openPoListings: OpenPOResponseDto[] = [];
  selectedVendors: OpenPOResponseDto[] = [];
  showLoader = false;
  vendorStatusId = "";

  @Output() closeModalOnOpenPOEvent = new EventEmitter();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _router: Router,
    private router: ActivatedRoute,
    private _vendorService: VendorService,
    public _clientsListingService: ClientsListingService
  ) {
    this.router.params.subscribe(params => {
      this.vendorStatusId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getAllOpenPO(this.vendorStatusId?.toString());
  }

  @Input() vendorIdFromModal = "";
  ngOnChanges() {
    if (this.vendorIdFromModal) {
      this.vendorStatusId = this.vendorIdFromModal;
    }
  }

  getCurrentVendor(accountnumber: string) {
    this._router.navigate(["/samplepo/samplepo-summary/" + accountnumber]);
    this.closeModalOnOpenPOEvent.emit(accountnumber);
  }

  onVendorRedirection() {
    this._router.navigate(["/vendors/add-vendor"]);
  }

  getAllOpenPO(vendorAccountNumber: string) {
    this.showLoader = true;
    this._vendorService
      .getAllOpenPO(vendorAccountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<OpenPOResponseDto[]>) => {
          this.openPoListings = res.data;
          this.showLoader = false;
        },
        error: () => {
          this.showLoader = false;
        },
      });
  }

  exportExcel() {
    this.showLoader = true;
    if (this.selectedVendors.length > 0) {
      this.exportExcelForFilterData(this.selectedVendors);
      this.showLoader = false;
    } else {
      this.exportExcelForFilterData(this.openPoListings);
      this.showLoader = false;
    }
  }

  exportExcelForFilterData(filterclientlist: OpenPOResponseDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["PO #"]: datum.poNumber,
        ["Status"]: datum.status,
        ["Vendor Name"]: datum.vendorName,
        ["Total PO Amount"]: datum.totalPOAmount,
        ["Total Unmatched Amount"]: datum.totalUnmatchedAmount,
        ["Total PO Qty"]: datum.totalPOQty,
        ["Total Merch"]: datum.totalMerch,
        ["Total Freight"]: datum.totalFreight,
        ["Total Tax"]: datum.totalTax,
        ["Date Created"]: new Date(datum.dateCreated ?? ""),
        ["In Hands Date"]: new Date(datum.inhandsDate ?? ""),
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OpenPOList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  checkboxSelection() {
    if (this.selectedVendors.length > 1 || this.selectedVendors.length == 0) {
      this._clientsListingService.setAttachmentState(true);
    } else {
      this._clientsListingService.setAttachmentState(false);
    }
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
